module.exports = __webpack_public_path__ + "static/LogoYellowHR-6972cb0ff4b7c42f05ca6c9c2ef2baa5.svg";